module.exports = __webpack_public_path__ + "static/pleskova-ecbf4301eceab8704589075a67ae8709.jpg";